import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _434cacba = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _5e49c24a = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _10d2ee04 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _53112960 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _726e6600 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _0e9ef514 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _d8f6f898 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _06b65f8f = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _185eb2d8 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _92fde10e = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _0ba804e6 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _4f8c1aa3 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _e02d5aae = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _7705c300 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _bd53a510 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _524df963 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _4da4738a = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _a30e2d80 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _273fef1b = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _28833e7b = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _50dcb9ea = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _a7eb609c = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _19a282e6 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _9ab59872 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _53f5b266 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _38b29c78 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _11298a8c = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _789dac48 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _3db2e9a6 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _e3fdc3fc = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _271a1439 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _80547c98 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _b75487d6 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _e90a9366 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _3a795262 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _56626c96 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _25deb890 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _675d0524 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _074c3890 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _4d974d40 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _668b3860 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _91a22028 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _9f6fc95a = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _4436053a = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _3ec4babd = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _2daf6589 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _690dd733 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _f0619266 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _7eb87415 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _38db8002 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _7f47d6c6 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _b29124e4 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _00cb8a91 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _f0963bfa = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _65fbc336 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _2b72251b = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _c36aee30 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _6c91c4f7 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _9d74da64 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _67bff4f9 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _8afdec46 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _0eba20b0 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _34ddbfbd = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _66ebe7f5 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _67e19ef8 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _5e7bb8cb = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _9ee29a34 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _585fb848 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _625de868 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _f5a8e980 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _b8740196 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _44ec9bce = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _6bc99ea6 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _990c7a4a = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _c6a1c906 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _a8d32c6a = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _434cacba,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _5e49c24a,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _10d2ee04,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _53112960,
    name: "calendar"
  }, {
    path: "/customer",
    component: _726e6600,
    name: "customer"
  }, {
    path: "/details",
    component: _0e9ef514,
    name: "details"
  }, {
    path: "/goals",
    component: _d8f6f898,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _06b65f8f,
    name: "maisoku"
  }, {
    path: "/media",
    component: _185eb2d8,
    name: "media"
  }, {
    path: "/privacy",
    component: _92fde10e,
    name: "privacy"
  }, {
    path: "/project",
    component: _0ba804e6,
    name: "project"
  }, {
    path: "/response",
    component: _4f8c1aa3,
    name: "response"
  }, {
    path: "/sale",
    component: _e02d5aae,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _7705c300,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _bd53a510,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _524df963,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _4da4738a,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _a30e2d80,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _273fef1b,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _28833e7b,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _50dcb9ea,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _a7eb609c,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _19a282e6,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _9ab59872,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _53f5b266,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _38b29c78,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _11298a8c,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _789dac48,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _3db2e9a6,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _e3fdc3fc,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _271a1439,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _80547c98,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _b75487d6,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _e90a9366,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _3a795262,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _56626c96,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _25deb890,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _675d0524,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _074c3890,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _4d974d40,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _668b3860,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _91a22028,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _9f6fc95a,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _4436053a,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _3ec4babd,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _2daf6589,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _690dd733,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _f0619266,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _7eb87415,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _38db8002,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _7f47d6c6,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _b29124e4,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _00cb8a91,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _f0963bfa,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _65fbc336,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _2b72251b,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _c36aee30,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _6c91c4f7,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _9d74da64,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _67bff4f9,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _8afdec46,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _0eba20b0,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _34ddbfbd,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _66ebe7f5,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _67e19ef8,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _5e7bb8cb,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _9ee29a34,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _585fb848,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _625de868,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _f5a8e980,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _b8740196,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _44ec9bce,
    name: "property-property",
    children: [{
      path: "contact",
      component: _6bc99ea6,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _990c7a4a,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _c6a1c906,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _a8d32c6a,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
